import { useState, useCallback } from 'react';

const KEY = 'bible_versions_v3';

// The parallel version is NOT a free choice — it is fixed by what the dialect was
// translated FROM. Tgdaya was translated from the KJV and 和合本, so those are the texts it
// actually corresponds to, clause for clause; showing it against 現中/GNB would pair it with
// translations it has no relationship to. Truku takes the other pair — 現中2019 and the GNB
// (Good News Bible), both UBS dynamic-equivalence texts the Truku UBS translation renders from.
//
// So the only thing the reader chooses is: Chinese, English, or both.
export const PAIR = {
  tgdaya: { zh: { key: 'hh', label: '和合本2010' }, en: { key: 'kjv', label: 'KJV' } },
  truku:  { zh: { key: 'xz', label: '現中2019' },   en: { key: 'gnb', label: 'GNB' } },
  // Toda: set when there is Toda scripture and we know its source texts.
  toda:   { zh: { key: 'xz', label: '現中2019' },   en: { key: 'gnb', label: 'GNB' } },
};

const DEFAULT = { zh: true, en: false };

export function useVersions() {
  const [sel, setState] = useState(() => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY));
      if (v && typeof v === 'object') return { ...DEFAULT, ...v };
    } catch (_) {}
    return DEFAULT;
  });

  const toggle = useCallback((which) => setState((cur) => {
    const next = { ...cur, [which]: !cur[which] };
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (_) {}
    return next;
  }), []);

  return { sel, toggle };
}

// The parallel texts under a unit: this dialect's own Chinese and/or English source.
export function shownVersions(sel, dialect, versions) {
  if (!versions) return [];
  const pair = PAIR[dialect] || PAIR.tgdaya;
  const out = [];
  if (sel.zh && versions[pair.zh.key]) {
    out.push({ key: pair.zh.key, label: pair.zh.label, text: versions[pair.zh.key] });
  }
  if (sel.en && versions[pair.en.key]) {
    out.push({ key: pair.en.key, label: pair.en.label, text: versions[pair.en.key] });
  }
  return out;
}
